export const DEFAULT_LOCALE = "en-US";

export const HOMEPAGE_MESSAGE_BUNDLE_NAME = "pages.homepage";
